import ActiveSelectableButton from "./ActiveSelectableButton";
import React from "react";


export default function RadioButton(props) {

	return (
		<div className='radio_button'>
			<div className='buttons'>
				<ActiveSelectableButton
					className='deselectable'
					{...props}
				/>
			</div>
		</div>
	);
}